import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Tooltip, Legend);

function Mixedchart({ sales_trending_cnt, sales_trending_gmv_amt, type }) {
    const { t } = useTranslation();
    const [mixedChartData, setMixedChartData] = useState(null);
    const [mixedChartOptions, setMixedChartOptions] = useState(null);
    
    useEffect(() => {
        if (!sales_trending_cnt || !sales_trending_gmv_amt) return;

        var data = sales_trending_cnt;
        if (type === "gmv") {
            data = sales_trending_gmv_amt;
        }

        const labels = data.filter(d => d.legend === "Daily Sales" || d.legend === "Daily GMV").map(d => d.axis_x);
        const dailySales = data.filter(d => d.legend === "Daily Sales" || d.legend === "Daily GMV").map(d => d.axis_y);
        const totalSales = data.filter(d => d.legend === "Total Sales" || d.legend === "Total GMV").map(d => d.axis_y);

        setMixedChartData({
            labels,
            datasets: [
                {
                    type: "line",
                    label: type === "gmv" ? "Total GMV" : "Total Sales",
                    data: totalSales,
                    borderColor: "#E04ACB",
                    backgroundColor: "#E04ACB",
                    fill: true,
                    tension: 0.3,
                    yAxisID: "y",
                    pointRadius: 0,
                    pointHoverRadius: 4,
                },
                {
                    type: "bar",
                    label: type === "gmv" ? "Daily GMV" : "Daily Sales",
                    data: dailySales,
                    backgroundColor: "#4F70FD",
                    yAxisID: "y2",
                }
            ]
        });

        setMixedChartOptions({
            responsive: true,
            interaction: {
                mode: "index",
                intersect: false,
            },
            stacked: false,
            plugins: {
                legend: {
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        pointStyle: "circle",
                        boxWidth: 10,
                        boxHeight: 10,
                    },
                },
                tooltip: { enabled: true },
                datalabels: { display: false },
                title: {
                    display: true,
                    text: t("Sales and GMV"),
                },
            },
            scales: {
                y: {
                    type: "linear",
                    position: "left",
                    title: {
                        display: true,
                        text: type === "gmv" ? "Total GMV" : "Total Sales",
                    },
                    ticks: {
                        callback: value => {
                            if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + "M";
                            if (value >= 1_000) return (value / 1_000).toFixed(1) + "K";
                            return value;
                        }
                    },
                    grid: {
                        drawOnChartArea: true,
                    }
                },
                y2: {
                    type: "linear",
                    position: "right",
                    title: {
                        display: true,
                        text: type === "gmv" ? "Daily GMV" : "Daily Sales",
                    },
                    ticks: {
                        callback: value => {
                            if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + "M";
                            if (value >= 1_000) return (value / 1_000).toFixed(1) + "K";
                            return value;
                        }
                    },
                    grid: {
                        drawOnChartArea: false,
                    }
                },
                x: {
                    ticks: {
                        maxRotation: 45,
                        minRotation: 45
                    }
                }
            }
        });
    }, [sales_trending_cnt, sales_trending_gmv_amt, type, t]);

    return (
        <Fragment>
            {mixedChartData && mixedChartOptions && (
                <Chart type="bar" data={mixedChartData} options={mixedChartOptions} />
            )}
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Mixedchart);